import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import MemberList from "../components/team/MemberList";
import Button from "../components/common/Button";
import Modal from "../components/common/Modal";
import MemberForm from "../components/team/MemberForm";
import { teamService } from "../services/team";
import { useAuthStore } from "../store/authStore";
import toast from "react-hot-toast";

const Team = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const queryClient = useQueryClient();
  const { user } = useAuthStore();
  const isAdmin = user?.role === "admin";

  const deleteMutation = useMutation({
    mutationFn: (id) => teamService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["team"] });
      toast.success("Member deleted");
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "Error deleting member");
    },
  });

  const handleEdit = (member) => {
    setSelectedMember(member);
    setIsModalOpen(true);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this member?")) {
      deleteMutation.mutate(id);
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Team Members</h1>
          <p className="text-sm text-gray-500 mt-1">Manage your team members</p>
        </div>
        {isAdmin && (
          <Button onClick={() => { setSelectedMember(null); setIsModalOpen(true); }}>Add Member</Button>
        )}
      </div>
      <MemberList
        onEdit={isAdmin ? handleEdit : null}
        onDelete={isAdmin ? handleDelete : null}
      />
      {isAdmin && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => { setIsModalOpen(false); setSelectedMember(null); }}
          title={selectedMember ? "Edit Team Member" : "Add Team Member"}
        >
          <MemberForm
            member={selectedMember}
            onSuccess={() => { setIsModalOpen(false); setSelectedMember(null); }}
          />
        </Modal>
      )}
    </div>
  );
};

export default Team;
